/**
 * Build a time-of-day greeting string.
 * Returns null if no firstName is provided.
 *
 * Selection is deterministic per calendar day: same greeting all day,
 * fresh tomorrow. Sunday morning gets its own special pool.
 */

function daySeed() {
  const s = new Date().toDateString();
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

function pick(pool) {
  return pool[daySeed() % pool.length];
}

const GREETINGS = {
  en: {
    sundayMorning: [
      "Happy Lord's Day, {name}",
      'Blessed Sunday, {name}',
      'His mercies are new this morning, {name}',
      'Rejoice and be glad, {name}',
      '{name}, today we gather in His name',
      "It's a good day to praise Him, {name}",
    ],
    morning: [
      'Good morning, {name}',
      'Rise and shine, {name}',
      'Walking by faith today, {name}',
      'His mercies are new, {name}',
      'Grace for the day, {name}',
      'Morning, {name} — press on in faith',
      'Seeking Him first this morning, {name}',
    ],
    afternoon: [
      'Good afternoon, {name}',
      'Pressing on, {name}',
      '{name}, keep the faith this afternoon',
      'Mid-day grace, {name}',
      'Stay rooted, {name}',
      "God's got this afternoon, {name}",
      'Running the race, {name}',
    ],
    evening: [
      'Good evening, {name}',
      'Evening peace, {name}',
      'Rest in His faithfulness, {name}',
      '{name}, grateful for today',
      'His grace carried you today, {name}',
      'Wind down in worship, {name}',
      'Reflect and give thanks, {name}',
    ],
  },
  es: {
    sundayMorning: [
      'Feliz día del Señor, {name}',
      'Bendecido domingo, {name}',
      'Sus misericordias son nuevas, {name}',
      'Alégrate y regocíjate, {name}',
      '{name}, hoy nos reunimos en Su nombre',
      'Es un buen día para alabarle, {name}',
    ],
    morning: [
      'Buenos días, {name}',
      'Levántate y brilla, {name}',
      'Caminando por fe hoy, {name}',
      'Sus misericordias son nuevas, {name}',
      'Gracia para el día, {name}',
      'Buenos días, {name} — sigue adelante en fe',
      'Buscando a Dios primero, {name}',
    ],
    afternoon: [
      'Buenas tardes, {name}',
      'Siguiendo adelante, {name}',
      '{name}, mantén la fe esta tarde',
      'Gracia para la tarde, {name}',
      'Permanece firme, {name}',
      'Dios tiene esta tarde, {name}',
      'Corriendo la carrera, {name}',
    ],
    evening: [
      'Buenas noches, {name}',
      'Paz en la noche, {name}',
      'Descansa en Su fidelidad, {name}',
      '{name}, agradecido por hoy',
      'Su gracia te llevó hoy, {name}',
      'Termina el día en adoración, {name}',
      'Reflexiona y da gracias, {name}',
    ],
  },
};

export function buildGreeting(firstName, lang = 'en') {
  if (!firstName) return null;
  const now = new Date();
  const hour = now.getHours();
  const pools = GREETINGS[lang] || GREETINGS.en;
  let slot;
  if (now.getDay() === 0 && hour < 12) slot = 'sundayMorning';
  else if (hour < 12) slot = 'morning';
  else if (hour < 17) slot = 'afternoon';
  else slot = 'evening';
  return pick(pools[slot]).replace('{name}', firstName);
}
